import { GenericService } from './generic.service';
import { Indicator } from '@/models';

export class IndicatorService extends GenericService<Indicator> {
  constructor() {
    super('v1/indicators');
  }
}
